import Vue from "vue";
import Vuex from "vuex";
import ApiCaller from '../utils/apicaller'
import constant from '../utils/constant'

Vue.use(Vuex)
/* eslint-disable */
export default new Vuex.Store({
    state: {
        banners: [],
        bannerId: 0,
        categories: [],
        merchandiseProdList: [],
        merchandisePageIndex: 0,
        filterProdList: {},
        trendingProductList: [],
        trendingProductId: 0,
        trendingListById: [],
        trendingListByIndex: 0,
        oldVideoList: [],
        oldVideoListIndex: 0,
        productDetail: [],
        discountedTrendingProducts: [],
        trendingIndex: 0,
        nonCarouselBanner: [],
        nonCarousel1: [],
        nonCarousel2: [],
        newCollectionList: [],
        newCollectionId: 0,
        collectionList: [],
        collectionId: 0,
        nonCarouselId: 0,
        categoriesProductResponses: [],
        underPriceCategory: [],
        categoryTree: [],
        priceSale: [],
        merchantId: 0,
        salesDiscountedProducts: [],
        pageIndex: 0,
        selectedFilterType: 1,
        comments: [],
        commentsData:{},
        commentIndex: 0,
        groupListData:{},
        groupIndex: 0,
        availGroupListData: {},
        availGroupIndex: 0,
        availCutPriceListData: {},
        availCutPriceIndex: 0,
        availablePreOrderData: null,
        saleID: 0,
        salesProducts: [],
        likes: {},
        likeIndex: 0,
        searchProducts: [],
        catgryName: {},
        orders: [],
        preOrders: [],
        orderIndex: 0,
        preOrderIndex: 0,
        productsVideos: [],
        productsWomenVideos: [],
        videoIndex: 0,
        details: {},
        saleRefID: 0,
        subCategoriesDto: [],
        categoryList: [],
        subCatId: 0,
        catId:0,
        catName:'',
        catIndex:0,
        micStatus:true,
        saveOrderDetails: {},
        groupPerchaseOrder:0,
        MerchantId:null
    },
    getters: {
        banners: state => state.banners,
        bannerId: state => state.bannerId,
        categories: state => state.categories,
        merchandiseProdList: state => state.merchandiseProdList,
        merchandisePageIndex: state => state.merchandisePageIndex,
        trendingListById: state => state.trendingListById,
        trendingListByIndex: state => state.trendingListByIndex,
        filterProdList:state => state.filterProdList,
        trendingProductList: state => state.trendingProductList,
        trendingProductId: state => state.trendingProductId,
        oldVideoList: state => state.oldVideoList,
        oldVideoListIndex: state => state.oldVideoListIndex,
        discountedTrendingProducts: state => state.discountedTrendingProducts,
        newCollectionList: state => state.newCollectionList,
        newCollectionId: state => state.newCollectionId,
        collectionList: state => state.collectionList,
        collectionId: state => state.collectionId,
        nonCarouselBanner: state => state.nonCarouselBanner,
        nonCarousel1: state => state.nonCarousel1,
        nonCarousel2: state => state.nonCarousel2,
        categoriesProductResponses: state => state.categoriesProductResponses,
        underPriceCategory: state => state.underPriceCategory,
        categoryTree: state => state.categoryTree,
        priceSale: state => state.priceSale,
        merchantId: state => state.merchantId,
        salesDiscountedProducts: state => state.salesDiscountedProducts,
        pageIndex: state => state.pageIndex,
        selectedFilterType: state => state.selectedFilterType,
        comments: state => state.comments,
        commentsData: state => state.commentsData,
        groupListData: state => state.groupListData,
        commentIndex: state => state.commentIndex,
        groupIndex: state => state.groupIndex,
        availGroupListData: state => state.availGroupListData,
        availGroupIndex: state => state.availGroupIndex,
        availCutPriceListData: state => state.availCutPriceListData,
        availCutPriceIndex: state => state.availCutPriceIndex,
        saleID: state => state.saleID,
        salesProducts: state => state.salesProducts,
        likes: state => state.likes,
        likeIndex: state => state.likeIndex,
        searchProducts: state => state.searchProducts,
        catgryName: state => state.catgryName,
        orders: state => state.orders,
        preOrders: state => state.preOrders,
        orderIndex: state => state.orderIndex,
        preOrderIndex: state => state.preOrderIndex,
        productsVideos: state => state.productsVideos,
        productsWomenVideos: state => state.productsWomenVideos,
        videoIndex: state => state.videoIndex,
        details: state => state.details,
        saleRefID: state => state.saleRefID,
        subCategoriesDto: state => state.subCategoriesDto,
        categoryList: state => state.categoryList,
        subCatId: state => state.subCatId,
        catId:state => state.catId,
        catName:state =>state.catName,
        catIndex:state =>state.catIndex,
        micStatus:state => state.micStatus,
        saveOrderDetails:state => state.saveOrderDetails,
        groupPerchaseOrder:state => state.groupPerchaseOrder,
        MerchantId:state=>state.MerchantId
    },
    mutations: {
        
        saveBanners(state, banners) {
            state.banners = banners.banners
            state.bannerId = banners.bannerId
        },
        saveGroupPerchaseOrder(state, order) {
            state.groupPerchaseOrder = order.orderId
        },
        saveNonCarouselBanner(state, nonCarouselBanner) {
            state.nonCarouselBanner = nonCarouselBanner.nonCarouselBanner
        }, 
        saveNonCarousel1(state,nonCarousel1) {
            state.nonCarousel1 = nonCarousel1.nonCarousel1
        }, 
        saveNonCarousel2(state,nonCarousel2) {
            state.nonCarousel2 = nonCarousel2.nonCarousel2
        },        
        saveCategories(state, categories) {
            state.categories = categories.categories
            state.catId = categories.catId,
            state.catIndex=categories.catIndex
        },
        saveMerchandiseData(state, merchandiseProdList){
            state.merchandiseProdList = merchandiseProdList.merchandiseProdList
            state.merchandisePageIndex = merchandiseProdList.merchandisePageIndex
        },
        saveMerchandiseFilterData(state, filterProdList){
            state.filterProdList = filterProdList.filterProdList
        },
        saveTrendingListById(state, trendingListById){
            state.trendingListById = trendingListById.trendingListById
            state.trendingListByIndex = trendingListById.trendingListByIndex
        },
        saveOldVideoData(state, oldVideoList){
            state.oldVideoList = oldVideoList.oldVideoList
            state.oldVideoListIndex = oldVideoList.oldVideoListIndex
        },
        saveCatId(state, catData){
            state.catId = catData.catId
            state.catName= catData.catName
            state.catIndex=catData.catIndex
        },
        saveTrendingProduct(state, trendingProductList) {
            state.trendingProductList = trendingProductList.trendingProductList
            state.trendingProductId = trendingProductList.trendingProductId
        },
        merchantId(state, merchantId) {
            state.merchantId = merchantId.merchantId
        },
        saveProductDetails(state, products) {
            state.details = products.details
            state.saleRefID = products.saleRefID
        },
        saveData(state, products) {
            if (products.type == 'trending') {
                state.discountedTrendingProducts = products.discountedTrendingProducts
                state.trendingIndex = products.trendingIndex
            } else if (products.type == 'search') {
                state.searchProducts = products.searchProducts
            } else if(products.type == 'Collection'){
                state.salesProducts = products.salesProducts
            }            
            else if (products.type == 'category') {
                state.catgryName = products.catgryName
            } else if (products.type == 'post_order') {
                state.orderIndex = products.orderIndex
                state.orders = products.orders
            } else if (products.type == 'pre_orders') {
                state.preOrders = products.preOrders
                state.preOrderIndex = products.preOrderIndex
            } else if (products.type == 'video') {
                state.productsVideos = products.productsVideos
            } else if (products.type == 'women_video') {
                state.productsWomenVideos = products.productsWomenVideos
            }

            if (products.pageIndex) {
                state.pageIndex = products.pageIndex
            }
            if (products.storeIndex) {
                state.storeIndex = products.storeIndex
            }
        },
        
        saveNewCollection(state, newCollectionList) {
            state.newCollectionList = newCollectionList.newCollectionList
            state.newCollectionId = newCollectionList.newCollectionId
        },
        saveCollectionForYou(state, collectionList) {
            state.collectionList = collectionList.collectionList
            state.collectionId = collectionList.collectionId
        },
        saveUnderPriceCategory(state, underPriceCategory) {
            state.underPriceCategory = underPriceCategory.underPriceCategory
            state.underPriceId = underPriceCategory.underPriceId
        },
        savepriceSale(state, priceSale) {
            state.priceSale = priceSale.priceSale
            state.priceSaleId = priceSale.priceSaleId
        },
        saveCategoriesProduct(state, categoriesProductResponses) {
            state.categoriesProductResponses = categoriesProductResponses.categoriesProductResponses
            state.categoriesProductId = categoriesProductResponses.categoriesProductId
        },
        saveCategoryTree(state, categoryTree) {
            state.categoryTree = categoryTree.categoryTree
        },
        saveDiscountedProduct(state, salesDiscountedProducts) {
            state.salesDiscountedProducts = salesDiscountedProducts.salesDiscountedProducts
            state.pageIndex = salesDiscountedProducts.pageIndex
            state.selectedFilterType = salesDiscountedProducts.selectedFilterType
        },
        commentList(state, products) {
            state.commentsData = products.commentsData
            state.commentIndex = products.commentIndex
        },
        saveMic(state,data){
         state.micStatus=data;
        },
        saveSubCategories(state, categories) {
            state.subCategoriesDto = categories.subCategoriesDto
            state.subCatId = categories.subCatId
        },
        saveCategoryList(state, category) {
            state.categoryList = category.categoryList
        },
        saveComments(state, products) {
            state.comments = products.comments
            state.saleID = products.saleID
        },
        saveProductsVideos(state, products) {
            state.searchProducts = products.productsVideos
            state.videoIndex = products.pageIndex
        },
        incrementLikeCommentCount(state, type) {
            state.salesProducts.map((product, i) => {
                if (type.type == 'like') {
                    if (product.saleReferenceID == type.saleReferenceID) {
                        product.upvote = Number(product.upvote) + 1
                        product.isUpvoteEnabled = false
                    }
                } else if (type.type == 'comment') {
                    if (product.saleReferenceID == type.saleReferenceID) {
                        product.commentCount = Number(product.commentCount) + 1
                    }
                }

            })
        },
        likeList(state, products) {
            state.likes = products.likes
            state.likeIndex = products.likeIndex
        },
        'PRODUCTDETAIL': (state, payload) => {
            state.productDetail = payload;
        },
        SaveOrderDetails(state , orderDetailObj){
            state.saveOrderDetails = orderDetailObj
        },
        saveGroupData(state, groups) {
            state.groupListData = groups.groupListData
            state.groupIndex = groups.commentIndex
        },
        saveAvailProductGroups(state, availGroups) {
            state.availGroupListData = availGroups.availGroupListData
            state.availGroupIndex = availGroups.availGroupIndex
        },
        saveAvailProductCutPrice(state, availCutPrice) {
            state.availCutPriceListData = availCutPrice.availCutPriceListData
            state.availCutPriceIndex = availCutPrice.availCutPriceIndex
        },
        savePreOrderDetail(state, availPreOrderData){
            state.availablePreOrderData = availPreOrderData.availablePreOrderData
        },
        saveMerchantId(state, obj){
            state.MerchantId = obj.MerchantId
        }

    },
    actions: {
        getMerchandiseHome({ commit }, { type, payload }) {
            return ApiCaller(constant.BANNER_URL, `merchandise-banners?carouselBanner=${payload}`, 'get', payload)
        },
        getAllCategories({ commit }, { type, payload }) {
            return ApiCaller(constant.BASE_URL, 'get-category-tree/' + payload, 'get')
        },
        getCatalogue({ commit }, { type, payload }) {
            return ApiCaller(constant.CATALOGUE_URL, 'get-category-tree', 'get')
        },
        getTrendingProduct({ commit }, { type, payload }) {
            return ApiCaller(constant.BASE_URL, 'get-trending-product', 'post', payload)
        },
        getProductType({ commit }, { type, payload }) {
            return ApiCaller(constant.BANNER_URL, 'merchandise-by-type/' + payload, 'get')
        },
        getMerchandiseProduct({ commit }, { type, payload }) {
            return ApiCaller(constant.BASE_URL, 'sales-listing-by-merchandise-id', 'post', payload)
        },
        getSalesListing({ commit }, { type, payload }) {
            return ApiCaller(constant.BASE_URL, 'sales-listing', 'post', payload)
        },
        getProductDetail({ commit }, { type, payload }) {
            let productDetail = ApiCaller(constant.BASE_URL, 'sales-details', 'post', payload)
            return productDetail
        },
        getSearchedProduct({ commit }, { type, payload, index }) {
            return ApiCaller(constant.SEARCH_URL, 'search-products/' + payload + '/' + index, 'get')
        },
        getSuggestionList({ commit }, { type, payload }) {
            return ApiCaller(constant.SEARCH_URL, 'suggest/' + payload, 'get')
        },
        getUserPriceProduct({ commit }, { type, payload }) {
            return ApiCaller(constant.BASE_URL, 'get-user-price-by-item-id/' + payload, 'get')
        },
        getShareDetailsByItem({ commit }, { type, payload }) {
            return ApiCaller(constant.BASE_URL, 'get-share-details-by-item/' + payload, 'get')
        },
        getCommentsBySale({ commit }, { type, payload, limit, index }) {
            return ApiCaller(constant.SOCIAL_URL, 'comments-by-sale/' + payload + '/' + limit + '/' + index, 'get')
        },
        addComment({ commit }, { type, payload }) {
            return ApiCaller(constant.SOCIAL_URL, 'add-comment', 'post', payload)
        },
        getLikeBySale({ commit }, { type, payload, limit, index }) {
            return ApiCaller(constant.SOCIAL_URL, 'like-by-sale/' + payload + '/' + limit + '/' + index, 'get')
        },
        actionOnSale({ commit }, { type, payload }) {
            return ApiCaller(constant.SOCIAL_URL, 'action-on-sale', 'post', payload)
        },
        getUserOrder({ commit }, { type, payload }) {
            return ApiCaller(constant.ORDER_URL, 'v2/get-user-order', 'post', payload)
        },
        getUserPreOrder({ commit }, { type, payload, limit, index }) {
            return ApiCaller(constant.ORDER_URL, 'get-user-pre-order-new/' + limit + '/' + index, 'get', payload)
        },
        // getUserPreOrderNew({ commit }, { type, payload, limit, index }) {
        //     return ApiCaller(constant.ORDER_URL, 'get-user-pre-order-new/' + limit + '/' + index, 'get', payload)
        // },
        CancelUserOrder({ commit }, { type, orderId, payload }) {
            return ApiCaller(constant.ORDER_URL, 'cancel-user-order/' + orderId, 'post', payload)
        },
        createPreOrder({ commit }, { type, payload }) {
            return ApiCaller(constant.ORDER_URL, 'create-pre-order', 'post', payload)
        },
        createPreOrderAgain({ commit }, { type, payload }) {
            return ApiCaller(constant.ORDER_URL, 'v2/create-pre-order', 'post', payload)
        },
        payBoardUser({ commit }, { type, payload }) {
            return ApiCaller(constant.PAYBOARD_URL, '/user/balance', 'get')
        },
        commentsBySaleAndTime({ commit }, { type, payload, Timestamp }) {
            return ApiCaller(constant.SOCIAL_URL, 'comments-by-sale-and-time/' + payload + '/' + Timestamp, 'get')
        },
        getCurrentLiveSale({ commit }, { type, payload }) {
            return ApiCaller(constant.BASE_URL, 'get-current-live-sale/10/0', 'get')
        },
        getLiveSale({ commit }, { type, payload }) {
            return ApiCaller(constant.BASE_URL, 'get-live-sale/10/0', 'get')
        },
        openLiveShow({ commit }, { type, payload, index }) {
            return ApiCaller(constant.BASE_URL, "get-live-sale-by-lang/" + index, 'get', payload)
        },
        getCategoryTreeBySaleType({ commit }, { type, payload }) {
            return ApiCaller(constant.BASE_URL, "get-category-tree-by-saleType/LIVE", 'get')
        },
        actionOnLiveShow({ commit }, { type, payload }) {
            return ApiCaller(constant.SOCIAL_URL, 'live-show/action-on-live-show', 'post', payload)
        },
        actionOnSale({ commit }, { type, payload }) {
            return ApiCaller(constant.SOCIAL_URL, 'action-on-sale', 'post', payload)
        },
        actionOnComment({ commit }, { type, payload }) {
            return ApiCaller(constant.SOCIAL_URL, 'action-on-comment', 'post', payload)
        },
        liveSale({ commit }, { type, payload }) {
            return ApiCaller(constant.BASE_URL, "live-sale", 'get')
        },
        getAddressesForUser({ commit }, { type, payload }) {
            return ApiCaller(constant.ADDRESS_URL, "getAddressesForUser", 'get')
        },
        getPreOrderById({ commit }, { type, payload }) {
            return ApiCaller(constant.ORDER_URL, "pre-order-by-id/" + payload, 'get')
        },
        getPincodeDetails({ commit }, { type, payload }) {
            return ApiCaller(constant.ORDER_URL, "get-pincode-details/" + payload, 'get')
        },
        createOrderByPreorder({ commit }, { type, payload }) {
            return ApiCaller(constant.ORDER_URL, 'create-order-by-pre-order', 'post', payload)
        },
        createOrderByPreorderAgain({ commit }, { type, payload }) {
            return ApiCaller(constant.ORDER_URL, 'v2/create-order-by-pre-order', 'post', payload)
        },
        orderById({ commit }, { type, payload }) {
            return ApiCaller(constant.ORDER_URL, "order-by-id/" + payload, 'get')
        },
        getLiveScheduleById({ commit }, { type, payload }) {
            return ApiCaller(constant.BASE_URL, 'get-live-schedule-by-id/' + payload, 'get')
        },
        getChatUser({ commit }, { type, payload }) {
            return ApiCaller(constant.PAYBOARD_URL, 'user/getuserlitedto/' + payload, 'get')
        },
        startChat({ commit }, { type, payload }) {
            return ApiCaller(constant.AI_URL, 'chatscreen/conversation', 'post', payload)
        },
        getReasonOrderReturn({ commit }, { type, payload }) {
            return ApiCaller(constant.ORDER_URL, "get-reson-by-type/ORDER_RETURN", 'get')
        },
        orderReturnInitiate({ commit }, { type, payload }) {
            return ApiCaller(constant.ORDER_RETURN_URL, 'order-return-initiate', 'post', payload)
        },
        getDukaanCategory({ commit }, { type, payload }) {
            return ApiCaller('//groupbuybe.payboard.in/dukaan/qr/', `${payload}/details`, 'get')
        },
        getDukaanQrUsers({ commit }, { type, payload }) {
            return ApiCaller(constant.ADDRESS_URL, 'qr/' + payload + '/details/', 'get')
        },
        postOrderReturnUrl({ commit }, { type, payload, postValue }){
            return ApiCaller(constant.ORDER_RETURN_URL, "add-bank-details/" + payload , 'post', postValue)
        },
        getGroup({ commit }, { type, payload }){
            return ApiCaller (constant.GET_GROUP_API, 'get-product-groups' , 'post', payload)
        },
        getAvailGroupsProduct({ commit }, { type, payload }){
            return ApiCaller (constant.BANNER_URL, 'merchandise-by-type/GROUP?page=' + payload , 'get')
        },
        getScratchValue({ commit }, { type, payload }){
            return ApiCaller (constant.SCRATCH_API_URL, 'scratch-option-by-application' , 'post', payload)
        },
        getRedeemAward({ commit }, { type, payload }){
            return ApiCaller (constant.SCRATCH_API_URL, 'redeem-reward' , 'post', payload)
        },
        getGroupNotify({ commit }, { type, payload }){
            return ApiCaller (constant.GET_GROUP_API, 'notifyGroupPurchase' , 'post', payload)
        },
        getCutPriceProductHistory({ commit }, { type, payload, itemId }){
            return ApiCaller (constant.BASE_URL, 'product-cutting-history-by-item/' + payload + '/' + itemId, 'get')
        },
        // https://groupbuybe.payboard.in/bannerService/merchandise-by-type/GROUP?page=0
    }
});